import { render } from "./AcceptableUsePolicy.vue?vue&type=template&id=ea025d10"
import script from "./AcceptableUsePolicy.vue?vue&type=script&lang=js"
export * from "./AcceptableUsePolicy.vue?vue&type=script&lang=js"

import "./AcceptableUsePolicy.vue?vue&type=style&index=0&id=ea025d10&lang=css"

import exportComponent from "/builds/vidict/ott-platform/procricket-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__